module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>credit-card</title><path d=\"M47.17,11.59H2.69A2.68,2.68,0,0,0,0,14.29V39.61A2.68,2.68,0,0,0,2.69,42.3H47.17a2.68,2.68,0,0,0,2.69-2.69V14.29A2.68,2.68,0,0,0,47.17,11.59Zm1.5,28a1.48,1.48,0,0,1-1.5,1.5H2.69a1.48,1.48,0,0,1-1.5-1.5v-1.5H48.67Zm0-8.2H1.2V14.29a1.48,1.48,0,0,1,1.5-1.5H47.17a1.48,1.48,0,0,1,1.5,1.5Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/credit-card.svg
// module id = 1028
// module chunks = 1